import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from "@angular/forms";
import { StateService } from '@uirouter/core';
import { confirmValidator } from '../../sso/confirm-validator';
import { requiredTrim } from '../../sso/trim-validator';
import { LocalStorageService } from "angular-2-local-storage";
import { ApiService } from "../../utils/api.service";
import { WindowRefService } from "../../utils/window.service";
import { FormService } from "../../utils/form.service";
import { AppService } from "../../utils/app.service";
import { AnalyticsService } from "../../utils/analytics.service";
import { TokenCookieService } from '../../utils/token-cookie.service';
@Component({
    selector: 'sign_up-page',
    template: require('./sign_up.html'),
})

export class SignUpPageWithBusinessComponent implements OnInit {
    private _window: any;
    public phoneMask = ['(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

    private signUpForm = {
        form: null,
        $submitting: false,
        $visible: true,
        $errorMsg: '',

        username: '',
        password: '',
        password_confirm: '',
        first_name: '',
        last_name: '',
        phone: '',
        business: {
            business_owners: [
                {
                    address: {
                        country: "US"
                    },
                    first_name: "Square",
                    last_name: "Space",
                    ownership: 100
                }
            ],
            address: {
                country: "US"
            },
            name: "",
            business_type: "",
            form_state: "",
            industry: ""
        },

        response_type: '',
        redirect_uri: '',
        accept_terms: null,
        promo: null
    };
    @Input() params: any;
    @Input() config: any;
    constructor(
        private app: AppService,
        private api: ApiService,
        private Analytics: AnalyticsService,
        private Form: FormService,
        private localStorageService: LocalStorageService,
        windowRef: WindowRefService,
        private Location: StateService,
        private fb: FormBuilder,
        private tokenCookieService: TokenCookieService
    ) {
        this._window = windowRef.nativeWindow;
        this.signUpForm.form = this.fb.group({
            username: [this.signUpForm.username, [Validators.required, Validators.email]],
            password: [this.signUpForm.password, [Validators.required,]],
            password_confirm: [this.signUpForm.password_confirm, [Validators.required, confirmValidator('password')]],
            phone: [this.signUpForm.phone, [Validators.required,]],
            first_name: [this.signUpForm.first_name, [Validators.required, requiredTrim()]],
            last_name: [this.signUpForm.last_name, [Validators.required, requiredTrim()]],
            accept_terms: [this.signUpForm.accept_terms, [Validators.requiredTrue]],
            businessName: ['', Validators.required],
            businessFormationState: ['', Validators.required],
            businessType: ['', Validators.required],
            businessIndustry: ['', Validators.required],
            businessOwnership: [100, Validators.required]
        });
    }

    ngOnInit() {
        this.app.config = this.config;

        if (this.params && this.params.client_id) {
            this.localStorageService.set('params', this.params);
        } else if (!this.params || !this.params.client_id) {
            this.app.setDefaultParams();
        }

        let authParams = <any>this.localStorageService.get('params');
        this.signUpForm.response_type = authParams.response_type;
        this.signUpForm.redirect_uri = authParams.redirect_uri;
        this.signUpForm.promo = authParams.promo;

        this.signUpForm.form.get('first_name').valueChanges.subscribe(value => {
            this.signUpForm.business.business_owners[0].first_name = value;
        })

        this.signUpForm.form.get('last_name').valueChanges.subscribe(value => {
            this.signUpForm.business.business_owners[0].last_name = value;
        })
    }

    isRegistrationError(response) {
        if (response.status === 403) {
            this.Analytics.trackEvent('Sign Up', 'Error', 'This email is already registered');
            this.signUpForm.$errorMsg = 'This email is already registered!<br/>'
                + '<a href="#/squarespace/login?username=' + this._window.encodeURIComponent(this.signUpForm.username) + '">Sign In</a>';
            return true;
        } else if (response.status === 400) {
            this.Analytics.trackEvent('Sign Up', 'Error', 'Invalid Information');
            return true;
        } else {
            return false;
        }

    };

    conenctToSquareSpace(data) {
        this.api.getBusinesses().then((res: any) => {
            this.tokenCookieService.setTokenCookie();
            this.app.connectSelectedBusinessToSS(data);
        }).catch(err => {
            this.signUpForm.$errorMsg = 'Error while proceeding please try again';
            this.signUpForm.$visible = true;
            this.signUpForm.$submitting = false;
        })
    }

    onSignUp_Success(response) {
        if (!this.isRegistrationError(response)) {
            this.signUpForm.$submitting = true;
            this.registerUser();
        }
    };

    onSignUp_Error(response) {
        if (!this.isRegistrationError(response)) {
            this.Location.go('error500');
        }
    };

    onSignUp_Invalid() {
        this.Analytics.trackEvent('Sign Up', 'Error', 'Provide required information');
    };

    signUp_Check() {
        this.signUpForm.phone = this.signUpForm.phone.replace(/[^0-9]/g, '');
        this.Form.submit(
            this.signUpForm,
            this.api.registerUserCheck.bind(this.api),
            this.onSignUp_Success.bind(this),
            this.onSignUp_Error.bind(this),
            this.onSignUp_Invalid.bind(this),
            null
        );
    };

    onRegister(res) {
        this.signUpForm.$visible = false;
        this.Analytics.trackEvent('Sign Up', 'Finish', null);
        this.localStorageService.set('access_token', res.o_auth_response.access_token);
        this.api.resetHeaders();
        this.conenctToSquareSpace(res);
    };

    registerUser() {
        this.Form.submit(
            this.signUpForm,
            this.api.registerWithBusiness.bind(this.api),
            this.onRegister.bind(this),
            null,
            this.onSignUp_Invalid.bind(this),
            null
        );
    };

    checkPhone() {
        if (this.signUpForm.phone && this.signUpForm.phone.replace(/[^0-9]/g, '').length === 10) {
            this.signUpForm.phone = this.signUpForm.phone.replace(/[^0-9]/g, '');
            return true;
        } else {
            this.signUpForm.phone = '';
            return false;
        }
    }
}
